exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".confirmation-container___2e733 {\n  text-align: center;\n  margin-bottom: 20px;\n}\n.social-invite-text___2nCgm {\n  margin: 40px 0 20px 0;\n}\n.center-text___2W5oK {\n  text-align: center;\n}\n.extra-margin___CpvTY {\n  margin: 30px 0 0 0;\n}\n", "", {"version":3,"sources":["/causefundraisernodeweb-ci-1233/workspace/causefundraisernodeweb-ci-1233/public/js/components/confirmation.less"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,oBAAoB;CACrB;AACD;EACE,sBAAsB;CACvB;AACD;EACE,mBAAmB;CACpB;AACD;EACE,mBAAmB;CACpB","file":"confirmation.less","sourcesContent":[".confirmation-container {\n  text-align: center;\n  margin-bottom: 20px;\n}\n.social-invite-text {\n  margin: 40px 0 20px 0;\n}\n.center-text {\n  text-align: center;\n}\n.extra-margin {\n  margin: 30px 0 0 0;\n}\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"confirmation-container": "confirmation-container___2e733",
	"social-invite-text": "social-invite-text___2nCgm",
	"center-text": "center-text___2W5oK",
	"extra-margin": "extra-margin___CpvTY"
};